<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">
              mdi-arrow-left
            </v-icon>
            Permission
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-tabs v-model="tab" class="tabs-learn-more">
          <v-tab class="text-none subtitle-1">
            Web
          </v-tab>
          <v-tab class="text-none subtitle-1">
            Android
          </v-tab>
          <v-tab class="text-none subtitle-1">
            iOS
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <h3 class="title">
                  Camera Permission
                </h3>
                <v-expansion-panels v-model="webCameraPanel" flat class="panel-permission">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0 py-3 blue--text text--darken-1 subtitle-1">
                      Chrome
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li>
                          Di kanan atas, klik Lainnya
                          <v-icon color="blue">
                            mdi-dots-vertical
                          </v-icon>
                        </li>
                        <li>
                          Klik
                          <b>Setelan</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          Di bagian bawah, klik<b>Lanjutan</b>.
                        </li>
                        <li>
                          Di bagian "Privasi dan keamanan", klik <b>Setelan konten</b>.
                        </li>
                        <li>
                          Klik "Kamera"
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          pastikan opsi <b>Tanya sebelum mengakses (direkomendasikan)</b> diaktifkan.
                        </li>
                        <li>
                          Klik Kembali
                          <v-icon color="blue">
                            mdi-arrow-left
                          </v-icon>.
                        </li>
                        <li>
                          Coba refresh ulang halaman
                          <v-icon color="blue">
                            mdi-reload
                          </v-icon>.
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0 py-3 blue--text text--darken-1 subtitle-1">
                      Firefox
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li>
                          Di kiri atas, klik
                          <v-icon color="blue">
                            mdi-camera
                          </v-icon>
                        </li>
                        <li>
                          Saat diminta izin untuk akses kamera Anda, pilih <b>Izinkan / Izinkan akses kamera</b> atau hapus <b>Blokir</b> jika akses <b>Di blokir</b>.
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0 py-3 blue--text text--darken-1 subtitle-1">
                      Opera
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li>
                          Di kanan atas, klik
                          <v-icon color="blue">
                            mdi-tune
                          </v-icon>
                        </li>
                        <li>
                          Pilih <b>Pergi ke setelan browser</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Lanjutan</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Privasi dan keamanan</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Pengaturan situs</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Kamera</b>
                        </li>
                        <li>
                          Hapus <b>Block</b>
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0 py-3 blue--text text--darken-1 subtitle-1">
                      Safari
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <p>
                        Saat diminta untuk membagikan kamera Anda, pilih <b>Izinkan</b>.
                      </p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <h3 class="title mt-3">
                  GPS Permission
                </h3>
                <v-expansion-panels v-model="webGPSPanel" flat class="panel-permission">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0 py-3 blue--text text--darken-1 subtitle-1">
                      Chrome
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li>
                          Di kanan atas, klik Lainnya
                          <v-icon color="blue">
                            mdi-dots-vertical
                          </v-icon>
                        </li>
                        <li>
                          Klik <b>Setelan</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          Di bagian bawah, klik <b>Lanjutan</b>.
                        </li>
                        <li>
                          Di bagian "Privasi dan keamanan", klik <b>Setelan konten</b>.
                        </li>
                        <li>
                          Klik "Lokasi"
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          pastikan opsi <b>Tanya sebelum mengakses (direkomendasikan)</b> diaktifkan.
                        </li>
                        <li>
                          Klik Kembali
                          <v-icon color="blue">
                            mdi-arrow-left
                          </v-icon>.
                        </li>
                        <li>
                          Coba refresh ulang halaman
                          <v-icon color="blue">
                            mdi-reload
                          </v-icon>.
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0 py-3 blue--text text--darken-1 subtitle-1">
                      Firefox
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li>
                          Di kiri atas, klik
                          <v-icon color="blue">
                            mdi-crosshairs-gps
                          </v-icon>
                        </li>
                        <li>
                          Saat diminta untuk membagikan lokasi Anda, pilih <b>Izinkan / Izinkan akses lokasi</b> atau hapus <b>Blokir</b> jika akses <b>Di blokir</b>.
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0 py-3 blue--text text--darken-1 subtitle-1">
                      Opera
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li>
                          Di kanan atas, klik
                          <v-icon color="blue">
                            mdi-tune
                          </v-icon>
                        </li>
                        <li>
                          Pilih <b>Pergi ke Setelan browser</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Lanjutan</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Privasi dan keamanan</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Pengaturan situs</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Lokasi</b>
                        </li>
                        <li>
                          Hapus <b>Block</b>
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0 py-3 blue--text text--darken-1 subtitle-1">
                      Safari
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <p>
                        Saat diminta untuk membagikan lokasi Anda, pilih <b>Izinkan</b>.
                      </p>
                      <p>
                        Anda mungkin diminta untuk mengubah setelan lokasi di komputer sebelum Anda bisa mengaktifkannya untuk Safari. Untuk melakukannya:
                      </p>
                      <ol>
                        <li>
                          Buka <b>System Preferences</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Security & Privacy Preferences</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Privacy</b>
                          <v-icon color="blue">
                            mdi-chevron-right
                          </v-icon>
                          <b>Location Services</b>.
                        </li>
                        <li>
                          Untuk memungkinkan perubahan, klik ikon kunci di kiri bawah.
                        </li>
                        <li>
                          Centang "Aktifkan Layanan Lokasi".
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <h3 class="title">
                  Camera Permission
                </h3>
                <ol>
                  <li>
                    Di ponsel atau tablet Android, buka aplikasi Setelan
                    <v-icon color="blue">
                      mdi-cog
                    </v-icon>
                  </li>
                  <li>
                    Tap <b>Manajemen Aplikasi</b>
                  </li>
                  <li>
                    Tap <b>Browser</b>.
                  </li>
                  <li>
                    Izinkan <b>Kamera</b>
                  </li>
                </ol>

                <h3 class="title mt-3">
                  GPS Permission
                </h3>
                <ol>
                  <li>
                    Di ponsel atau tablet Android, buka aplikasi Setelan
                    <v-icon color="blue">
                      mdi-cog
                    </v-icon>
                  </li>
                  <li>
                    Tap <b>Manajemen Aplikasi</b>
                  </li>
                  <li>
                    Tap <b>Browser</b>.
                  </li>
                  <li>
                    Izinkan <b>Lokasi</b>
                  </li>
                </ol>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <h3 class="title">
                  Camera Permission
                </h3>
                <ol>
                  <li>
                    Tap <b>Setelan</b>
                    <v-icon color="blue">
                      mdi-cog
                    </v-icon>
                  </li>
                  <li>
                    Tap <b>Safari</b>
                  </li>
                  <li>
                    Aktifkan <b>Akses kamera & mikropon</b>
                  </li>
                </ol>

                <h3 class="title mt-3">
                  GPS Permission
                </h3>
                <ol>
                  <li>
                    Tap <b>Setelan</b>
                    <v-icon color="blue">
                      mdi-cog
                    </v-icon>
                  </li>
                  <li>
                    Tap <b>Privasi</b>
                  </li>
                  <li>
                    Tap <b>Layanan Lokasi</b>
                  </li>
                  <li>
                    Tap <b>Safari</b> dan ganti dari <b>Tidak pernah</b> menjadi <b>Saat Menggunakan Aplikasi</b>
                  </li>
                </ol>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      tab: null,
      items: [
        { tab: 'Web', content: 'Tab 1 Content' },
        { tab: 'Android', content: 'Tab 2 Content' },
        { tab: 'iOS', content: 'Tab 3 Content' }
      ],
      webCameraPanel: 0,
      webGPSPanel: 0
    }
  },
  methods: {
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    }
  }
}
</script>
